import { useId } from 'react';

import lightningHeroCheckboxCheck from '../../../../../assets/lightning-hero_checkbox-check.svg';
import polyglot from '../../../../../localization';

import './styles.scss';

/**
 * Checkbox component renders a checkbox with a checked state and a change handler.
 *
 * @param {'bg' | 'en' | 'pt' | 'ro' | 'escl' | 'espe' | 'sr'} lang — Language key used to localize checkbox label.
 * @param {string} altText - alt text
 * @param {boolean} checked - checked state
 * @param {function} onChange - change handler
 * @param {string} [className] - additional className
 */

export const LightningHeroCheckbox = ({
    lang,
    altText,
    checked,
    onChange,
    className,
}) => {
    const inputId = useId();

    return (
        <label className={`cb ${className || ''}`} htmlFor={inputId}>
            <input
                type='checkbox'
                checked={checked}
                onChange={onChange}
                id={inputId}
                name={inputId}
                className='cb__input'
            />

            <span className='cb__box' aria-hidden='true'>
                {checked && (
                    <img
                        src={lightningHeroCheckboxCheck}
                        alt={altText}
                        width={28}
                        height={28}
                        className='cb__icon'
                    />
                )}
            </span>

            <span className='cb__label'>
                {polyglot.t(`${lang}.hero.checkbox`)}
            </span>
        </label>
    );
};
